class MobileMenu {
  constructor() {
    this.menu = document.querySelector('.navMain');
    this.hamburger = document.querySelector('.hamburger');
    this.exit = document.querySelector('.exit');
    this.header = document.querySelector('.mobileHeader');
    this.backArrow = document.querySelector('.backArrow');
    this.navOverlay = document.querySelector('.navOverlay');
    this.headerMenu = document.querySelector('.headerMenu');
    this.currentMenu;
    this.currentLevel = 0;

    if (window.innerWidth < 1140) {
      this.headerMenu.classList.add('headerMenu--hidden');
      this.events();
    }
  }
  events() {
    /* Hamburger-knapp */
    if (this.hamburger) {
      this.hamburger.addEventListener('click', (ev) => {
        this.menu.classList.add('navMain--open');
        this.navOverlay.classList.add('navOverlay--open');
        this.hamburger.classList.add('hamburger--hidden');
        this.exit.classList.remove('exit--closed');
        this.headerMenu.classList.remove('headerMenu--hidden');
        this.header.firstElementChild.style.display = "none";
      });
    }

    /* Exit-knapp */
    if (this.exit) {
      this.exit.addEventListener('click', (ev) => {
        this.menu.classList.remove('navMain--open');
        this.navOverlay.classList.remove('navOverlay--open');
        this.hamburger.classList.remove('hamburger--hidden')
        this.exit.classList.add('exit--closed');
        this.headerMenu.classList.add('headerMenu--hidden');
        this.goToStart();
      });
    }

    /* Menu items */
    this.menu.addEventListener('click', (ev) => {
      this.currentMenu = ev.target.closest('li');
      if (!this.currentMenu.classList.contains('menu-item-has-children') && this.currentLevel == 0) return;
      this.currentLevel++;
      if (this.currentLevel != 0) {
        this.headerMenu.querySelector('h2').innerHTML = "Gå tilbake";
        this.header.firstElementChild.style.display = "block";
        this.hideItemsExcept(this.currentMenu);
      }
    });

    /* Back-button */
    this.header.addEventListener('click', ev => {
      if (this.header.querySelector('h2').innerHTML !== "Meny") {


      if (this.currentLevel - 1 != 0) {
        this.currentLevel--;
      } else {
        this.goToStart();
        return;
      }

      this.currentMenu.classList.remove('navMain__submenu--hidden');
      let oldMenu = this.currentMenu.querySelector('.navMain__submenu--open').classList.remove('navMain__submenu--open');

      let parent = this.currentMenu.closest('.menu-item-has-children').parentElement;
      let newMenu = parent.querySelectorAll('.navMain__link--hidden');
      newMenu.forEach(item => {
        item.classList.remove('navMain__link--hidden');
      });
    }
  });
  }

  hideItemsExcept(current) {
    let menuItems = document.querySelectorAll('.navMain .navMain__item');
    menuItems.forEach(item => {
      item.firstElementChild.classList.add('navMain__link--hidden')
    });

    let submenu = current.querySelector('.navMain__submenu');
    submenu.classList.toggle('navMain__submenu--open');

    let items = submenu.querySelectorAll('.navMain__item');
    items.forEach(item => {
      item.firstElementChild.classList.remove('navMain__link--hidden');
    });

  }

  goToStart() {
    this.currentLevel = 0;
    let menuItems = document.querySelectorAll('.navMain__submenu--open');
    menuItems.forEach(menu => {
      menu.classList.remove('navMain__submenu--open');
    })

    let topLevelItems = document.querySelectorAll('.navMain > .navMain__item');
    topLevelItems.forEach(item => {
      item.firstElementChild.classList.remove('navMain__link--hidden');
    })

    this.header.querySelector('h2').innerHTML = "Meny";
    this.header.firstElementChild.style.display = "none";
  }
}

  export default MobileMenu;